import React from 'react';

import { currencyFormat } from 'utils/currencyFormat';
import User from 'entities/user/model';
import { Features } from 'utils/features';
import { Privileges } from 'utils/privileges';

const OrganizationTotalsBar: React.FC<{
  totalDonations?: number;
  totalHours?: number;
  totalDeeds?: number;
  user: User;
  loading: boolean;
}> = ({ totalDeeds, totalDonations, totalHours, user, loading }) =>
  loading ? null : (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginRight: 300,
        }}
      >
        {user?.hasPrivilege(Privileges.DONATION_VIEW) && user?.hasFeature(Features.DONATIONS) && (
          <div>
            <p>Total Donations</p>
            <h2>
              {totalDonations === null
                ? '—'
                : currencyFormat(totalDonations, user?.displayCurrency)}
            </h2>
          </div>
        )}
        {user?.hasPrivilege(Privileges.VOLUNTEERTIME) &&
          user?.hasFeature(Features.VOLUNTEERING) && (
            <div>
              <p>Total Hours Volunteered</p>
              <h2>
                {totalHours === null ? '—' : Math.round((totalHours + Number.EPSILON) * 100) / 100}
              </h2>
            </div>
          )}
        <div>
          <p>Total Deeds</p>
          <h2>{totalDeeds === null ? '—' : totalDeeds}</h2>
        </div>
      </div>
    </div>
  );

export default OrganizationTotalsBar;
